import { createApp } from "vue";
import App from "./App.vue";
import Quasar from 'quasar/src/vue-plugin.js';;
import quasarUserOptions from "./quasar-user-options";
import router from "./router";
import i18n from "./i18n";
import { store } from "./store/store";
import firebase from "firebase";
import Chat from "vue3-beautiful-chat";
import "animate.css";

const firebaseConfig = {
  apiKey: "AIzaSyCqmJdU28IuKixKr7aUf58etDGC0Txj_eg",

  authDomain: "asptmr-platforma.firebaseapp.com",

  databaseURL:
    "https://asptmr-platforma-default-rtdb.europe-west1.firebasedatabase.app",

  projectId: "asptmr-platforma",

  storageBucket: "asptmr-platforma.appspot.com",

  messagingSenderId: "467606278186",

  appId: "1:467606278186:web:3ab82b5931facab2f0f353",

  measurementId: "G-WL0GD49JY3",
};

firebase.initializeApp(firebaseConfig);
firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    // console.log("Logat")
    firebase
      .database()
      .ref("users/" + firebase.auth().currentUser.uid)
      .get()
      .then((snapshot) => {
        const data = snapshot.val();
        data.uid = firebase.auth().currentUser.uid;
        store.commit({
          type: "SET_USER",
          data: data,
        });
        // console.log("Data sent")
      });
    store.dispatch("fetchUser", user);
  } else {
    // console.log('NO DATA');
  }
});

let app = createApp(App).use(Quasar, quasarUserOptions);

app.use(store).use(Chat).use(i18n).use(router).use(firebase).mount("#app");
